import { useApiClient } from "@/src/hooks/useApiClient";

/** Cinq inscrits : assez pour voir une vague d'arrivées, pas une liste. */
export const NEW_ACCOUNTS_PREVIEW = 5;

/**
 * Les derniers comptes créés, et combien il y en a en tout.
 *
 * Un seul appel pour les deux : `total` est un `count(*)` sur le filtre,
 * indépendant de `limit` — trier par date décroissante donne donc la vitrine et
 * le compteur d'un coup.
 */
export function useAccountPulse() {
  const $api = useApiClient();

  const { data, isLoading, isError } = $api.useQuery(
    "get",
    "/api/v1/moderation/accounts",
    {
      params: {
        query: {
          limit: NEW_ACCOUNTS_PREVIEW,
          sort: "createdAt",
          order: "desc",
        },
      },
    },
  );

  return {
    accounts: data?.data?.accounts ?? [],
    // `undefined` tant que le serveur n'a pas répondu, pas `0`.
    total: data?.data?.total,
    isLoading,
    isError,
  };
}
